import React, { useEffect, useState } from "react";
import { svgimages } from "../../utils/svgimages";
import { Box } from "@mui/system";
import { add } from "date-fns";
import {
  Button,
  Grid,
  InputLabel,
  Link,
  Snackbar,
  TextField,
} from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Login({
  login_Handler,
}: {
  login_Handler: (loggedIn: boolean, username: string) => void;
}) {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        loginHandler();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
    // eslint-disable-next-line
  }, [username, password]);

  const loginHandler = async () => {
    try {
      const response = await axios.post(
        "https://api.portal.equilaw.uk.com/Access/Authenticate",
        {
          username: username,
          password: password,
        }
      );

      const token = response.data;
      if (token) {
        const expiryTime: Date = add(new Date(), {
          seconds: 720 * 60,
        });
        const cookieOptions = {
          expires: expiryTime,
          path: "/",
          sameSite: "strict" as "strict",
          secure: window.location.origin.indexOf("equilaw") !== -1 || undefined,
        };
        new Cookies().set("portal-token", token, cookieOptions);
        login_Handler(true, username);
      } else {
        setOpen(true);
        login_Handler(false, username);
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === "username") {
      setUsername(event.target.value);
    } else if (event.target.name === "password") {
      setPassword(event.target.value);
    }
  };

  return (
    <Grid container>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={8} md={3}>
        <Box textAlign={"center"} marginTop={2}>
          <img
            width="100%"
            src={svgimages["equilaw-logo"]}
            alt="Equilawlogo1651"
          />
        </Box>
      </Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={8} md={3}>
        <Box marginTop={8}>
          <InputLabel
            sx={{ textAlign: "left", marginBottom: "2vh" }}
            htmlFor="email"
          >
            Username
          </InputLabel>
          <TextField
            onChange={handleChange}
            value={username}
            fullWidth
            id="username"
            name="username"
            variant="outlined"
          />
        </Box>
      </Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={8} md={3}>
        <Box marginTop={2}>
          <InputLabel
            sx={{ textAlign: "left", marginBottom: "2vh" }}
            htmlFor="password"
          >
            Password
          </InputLabel>
          <TextField
            onChange={handleChange}
            value={password}
            name="password"
            type="password"
            fullWidth
            id="password"
            variant="outlined"
          />
        </Box>
      </Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Grid item xs={8} md={3}>
        <Box marginTop={4} textAlign={"left"}>
          <Grid container>
            <Grid item xs={6}>
              <Button
                onClick={loginHandler}
                variant="contained"
                sx={{ bgcolor: "#DE8646" }}
              >
                Login
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Link
                fontSize={14}
                color="#DE8646"
                component={RouterLink}
                to="/forgotten-password"
              >
                Forgotten Password?
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={2} md={4.5}></Grid>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="info" sx={{ width: "100%" }}>
          Your username or password is incorrect, please try again or reset it
          by choosing "Forgotten Password?"
        </Alert>
      </Snackbar>
    </Grid>
  );
}
